export default "__VITE_ASSET__3192ae8c__"